// extracted by mini-css-extract-plugin
module.exports = {"icon":"InReplyTo-icon-3F4IS","username":"InReplyTo-username-ADpWQ","inReplyTo":"InReplyTo-inReplyTo-1Y5P6"};